import React, { useState, useEffect } from "react";
import styles from "./chat.module.css";
import ConversaionCard from "./ConversaionCard";
import axios from "axios";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { useLocation } from "react-router-dom";

const ConversaionList = () => {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [emptyList, setEmptyList] = useState(false);
  const location = useLocation();

  const getConversations = async () => {
    try {
      const res = await axios.get(
        `https://arianaapp.arianaapply.com/api/V1/get-clients-for-admissioner/${location.state?.userDetails?._id}`
      );

      setLoading(false);
      if (res.data.length === 0) {
        setEmptyList(true);
      } else {
        setConversations(res.data);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (location.state?.userDetails?._id) {
      getConversations();
    } else {
      setLoading(false);
      setEmptyList(true);
    }
  }, [location.state]);

  return (
    <div className={styles.conversationList}>
      <Header title="گفتگوها" />
      <div className={styles.messenger}>
        {loading ? (
          <div className="spinner">
            <Loader
              type="TailSpin"
              color="rgb(236, 177, 28)"
              height={80}
              width={80}
            />
          </div>
        ) : emptyList ? (
          <p className={styles.emptyList}>
            در حال حاضر گفتگویی برای شما وجود ندارد
          </p>
        ) : (
          conversations.map((c) => (
            <ConversaionCard
              key={c._id}
              conv={c}
              user={location.state.userDetails}
            />
          ))
        )}
      </div>
      <Footer />
    </div>
  );
};

export default ConversaionList;